import { Box, CircularProgress, useTheme } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import Logo from '@/assets/images/svg/TSV_Logo.svg';
import LandingPageShell from '@/components/LandingPageShell';
import { getDefaultRunningMessages } from '@/components/LandingPageShell/landing-messages';
import AuthenticationModal from '@/components/Modal/AuthenticationModal';
import { useAuth } from '@/contexts/AuthContext';
import { fromTenantLandingInfo } from '@/pages/admin/clientManagement/ClientOnBoarding/LoginPageCustomizer/landing-config';
import { RootState } from '@/store';

const HomePage = () => {
  const theme = useTheme();
  const {
    initiateLogin,
    isLoginLoading,
    tenantInfo,
    isLoading: isAuthLoading,
  } = useAuth();
  const { mode } = useSelector((state: RootState) => state.tenant.themeMode);
  const [openDialog, setOpenDialog] = useState(false);

  const landingConfig = fromTenantLandingInfo(tenantInfo);

  const logo =
    mode === 'dark'
      ? tenantInfo?.darkLogoFilePath || Logo
      : tenantInfo?.lightLogoFilePath || Logo;

  const handleAzureLogin = async () => {
    if (tenantInfo?.authenticationType === 'BOTH') {
      setOpenDialog(true);
      return;
    }
    await initiateLogin();
  };

  if (isAuthLoading) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        height='100vh'
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box height='100dvh'>
      <LandingPageShell
        c={landingConfig}
        logo={logo}
        messages={getDefaultRunningMessages(theme)}
        onLoginClick={handleAzureLogin}
        loginLoading={isLoginLoading}
      />
      {openDialog && (
        <AuthenticationModal
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
        />
      )}
    </Box>
  );
};

export default HomePage;
